import { render } from "./ExpressPayment.vue?vue&type=template&id=2b93cca8&scoped=true"
import script from "./ExpressPayment.vue?vue&type=script&lang=js"
export * from "./ExpressPayment.vue?vue&type=script&lang=js"

import "./ExpressPayment.vue?vue&type=style&index=0&id=2b93cca8&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b93cca8"]])

export default __exports__